import angular from 'angular';
import LaunchService from './app-launch.service';

export default angular.module('autoboard.launchModule', [LaunchService])
  .name;
